var _class, _InternalBundleUnit;
import classNames from 'classnames';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { AsyncCourseDynamicPriceText, AsyncPriceCourseCard, AsyncPriceCourseCardContext, BrowseCourseCard, BrowseCourseCardContext } from '@udemy/browse-course';
import { discoveryTracker } from '@udemy/browse-event-tracking';
import { GenericAddToCart } from '@udemy/cart-temp-migration';
import { TrackingContextProvider } from '@udemy/event-tracking';
import { withI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { AlertBanner } from '@udemy/react-messaging-components';
import { Loader } from '@udemy/react-reveal-components';
import { ShoppingClient } from '@udemy/shopping';
import { PURCHASE_PRICE_TYPES } from '@udemy/shopping';
import { withUDData } from '@udemy/ud-data';
import { AddToCart } from '../add-to-cart/add-to-cart.react-component';
import { UnitTitle } from '../unit-title/unit-title.react-component';
import { BundleUnitSkeleton } from './bundle-unit-skeleton.react-component';
import { BundleUnitStore } from './bundle-unit.mobx-store';
import styles from "./bundle-unit.module.css";
export let InternalBundleUnit = observer(_class = (_InternalBundleUnit = class InternalBundleUnit extends React.Component {
  constructor(_props) {
    super(_props);
    this.bundleUnitStore = void 0;
    this.renderCourseCardImage = (ImageComponent, props) => {
      return /*#__PURE__*/React.createElement(ImageComponent, Object.assign({}, props, {
        className: classNames(props.className, styles['course-unit-image'])
      }));
    };
    // Render function for BrowseCourseProductCard that doesn't limit image size
    // BrowseCourseProductCard manages its own image sizing based on size prop
    this.renderCourseProductCardImage = (ImageComponent, props) => {
      // Don't add course-unit-image class to avoid 200px width limitation
      // BrowseCourseProductCard will handle its own image sizing
      return /*#__PURE__*/React.createElement(ImageComponent, props);
    };
    const {
      pageType,
      pageObjectId,
      udData,
      unit
    } = _props;
    this.bundleUnitStore = this.props.bundleUnitStore ? this.props.bundleUnitStore : new BundleUnitStore(pageType, pageObjectId, udData, unit);
  }
  componentDidMount() {
    if (!this.props.bundleUnitStore) {
      this.bundleUnitStore.fetchData();
    }
  }
  renderInContainer(content) {
    if (!this.props.applyBorder) {
      return content;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.isSingleSelectableUnit && /*#__PURE__*/React.createElement("div", {
      "data-testid": "single-selectable-unit-separator",
      className: styles['single-selectable-unit-separator']
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames(styles['bundle-border'], {
        [styles['single-selectable-unit-border']]: this.props.isSingleSelectableUnit
      }),
      "data-testid": "bundle-border"
    }, content));
  }
  getBundleUnitItems() {
    var _this$bundleUnitStore3, _this$bundleUnitStore4;
    if (this.props.isSingleSelectableUnit) {
      var _this$bundleUnitStore, _this$bundleUnitStore2;
      const cartItems = ShoppingClient.lists.cart.items;
      const cartItemIds = new Set(cartItems.map(cartItem => cartItem.buyable.id));
      const bundleItems = (_this$bundleUnitStore = (_this$bundleUnitStore2 = this.bundleUnitStore.unit) === null || _this$bundleUnitStore2 === void 0 ? void 0 : _this$bundleUnitStore2.items) !== null && _this$bundleUnitStore !== void 0 ? _this$bundleUnitStore : [];
      return bundleItems.filter(item => !cartItemIds.has(item.id));
    }
    return (_this$bundleUnitStore3 = (_this$bundleUnitStore4 = this.bundleUnitStore.unit) === null || _this$bundleUnitStore4 === void 0 ? void 0 : _this$bundleUnitStore4.items) !== null && _this$bundleUnitStore3 !== void 0 ? _this$bundleUnitStore3 : [];
  }
  getCartButtonTextAdd() {
    const {
      gettext
    } = this.props;
    if (this.getForceGoToCart()) {
      return gettext('Add all and go to cart');
    }
    return gettext('Add all to cart');
  }
  getCartButtonTextGoToCart() {
    const {
      gettext
    } = this.props;
    if (this.getForceGoToCart()) {
      return gettext('Going to cart');
    }
    return gettext('Go to cart');
  }
  getForceGoToCart() {
    var _this$bundleUnitStore5;
    if ((_this$bundleUnitStore5 = this.bundleUnitStore.unit) !== null && _this$bundleUnitStore5 !== void 0 && _this$bundleUnitStore5.fbt_go_direct_to_cart) {
      return this.props.forceGoToCart;
    }
    return false;
  }
  renderAddToCartIconButton(buyable) {
    return /*#__PURE__*/React.createElement(GenericAddToCart, {
      buyables: [buyable],
      buttonStyleProps: {
        round: true,
        udStyle: 'ghost',
        title: buyable === null || buyable === void 0 ? void 0 : buyable.title
      },
      disableOnGoToCart: true,
      shoppingClient: ShoppingClient,
      cartButtonClassesAdd: styles['single-selectable-add-to-cart-button'],
      iconName: "expand-plus",
      showIconOnly: true,
      loader: /*#__PURE__*/React.createElement(Loader, {
        color: "inherit",
        size: "small"
      })
    });
  }
  renderUnit() {
    var _this$bundleUnitStore6, _this$bundleUnitStore7, _this$bundleUnitStore8;
    const {
      gettext,
      interpolate,
      isSingleSelectableUnit,
      isBundleDiscountEnabled,
      bundleDiscountCode
    } = this.props;
    if (!this.bundleUnitStore.unit) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnitTitle, {
      typography: this.props.titleTypography,
      unit: (_this$bundleUnitStore6 = this.bundleUnitStore) === null || _this$bundleUnitStore6 === void 0 ? void 0 : _this$bundleUnitStore6.unit,
      forcedSubtitle: this.props.subtitle
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-container']
    }, this.getBundleUnitItems().map((course, i) => {
      var _this$props$uiRegion, _this$props$useCourse, _this$context;
      const plusIcon = i > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles['plus-icon-wrapper']
      }, /*#__PURE__*/React.createElement(Icon, {
        glyph: "expand-plus",
        size: "large",
        label: false
      }));
      return /*#__PURE__*/React.createElement(TrackingContextProvider, {
        key: course.id,
        trackingContext: {
          trackImpressionFunc: discoveryTracker.trackDiscoveryImpression,
          backendSource: this.bundleUnitStore.backendSource,
          index: i,
          uiRegion: (_this$props$uiRegion = this.props.uiRegion) !== null && _this$props$uiRegion !== void 0 ? _this$props$uiRegion : 'bundle-unit'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames(styles['course-unit-container'], {
          [styles['single-selectable-add-to-cart-container']]: isSingleSelectableUnit
        })
      }, ((_this$props$useCourse = this.props.useCourseProductCard) !== null && _this$props$useCourse !== void 0 ? _this$props$useCourse : (_this$context = this.context) === null || _this$context === void 0 ? void 0 : _this$context.useCourseProductCard) ? /*#__PURE__*/React.createElement(AsyncPriceCourseCardContext.Provider, {
        value: {
          useCourseProductCard: true,
          hideCourseDescription: true
        }
      }, /*#__PURE__*/React.createElement(AsyncPriceCourseCard
      // WARNING: this type assertion could hide bugs:
      , {
        course: course,
        className: styles['bundle-course-card'],
        layout: "horizontal",
        size: "medium",
        priceProps: {
          showListPriceOnly: false,
          listPriceClassName: 'bundle-course-price'
        },
        showDetails: false,
        renderCourseImage: this.renderCourseProductCardImage
      })) : /*#__PURE__*/React.createElement(BrowseCourseCardContext.Provider, {
        value: {
          cardComponent: BrowseCourseCard.defaultCardComponent
        }
      }, /*#__PURE__*/React.createElement(AsyncPriceCourseCard
      // WARNING: this type assertion could hide bugs:
      , {
        course: course,
        size: "large",
        className: styles['bundle-course-card'],
        priceProps: {
          showListPriceOnly: false,
          listPriceClassName: 'bundle-course-price'
        },
        showDetails: false,
        renderCourseImage: this.renderCourseCardImage
      })), !isSingleSelectableUnit ? plusIcon : this.renderAddToCartIconButton(course)));
    })), ((_this$bundleUnitStore7 = this.bundleUnitStore.unit) === null || _this$bundleUnitStore7 === void 0 ? void 0 : _this$bundleUnitStore7.fbt_discount_savings_percent) && /*#__PURE__*/React.createElement(AlertBanner, {
      className: styles['fbt-discount-banner'],
      title: interpolate(gettext('Save an extra %(rate)s% in cart when you buy these together'), {
        rate: this.bundleUnitStore.unit.fbt_discount_savings_percent
      }, true),
      icon: /*#__PURE__*/React.createElement(Icon, {
        glyph: "offer",
        label: false
      }),
      showCta: false
    }), !isSingleSelectableUnit && /*#__PURE__*/React.createElement("div", {
      className: styles['footer-container']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['price-text-container']
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames('ud-text-lg', styles['price-text-prefix'])
    }, gettext('Total:')), /*#__PURE__*/React.createElement(AsyncCourseDynamicPriceText, {
      buyables: this.bundleUnitStore.unit.items,
      listPriceClassName: "ud-text-md",
      discountPriceClassName: "ud-heading-lg",
      trackingEventContext: {
        priceType: PURCHASE_PRICE_TYPES.bundle
      },
      isBundleDiscountEnabled: isBundleDiscountEnabled,
      bundleDiscountCode: bundleDiscountCode
    })), /*#__PURE__*/React.createElement(AddToCart, {
      uiRegion: 'bundle-unit',
      buyables: toJS((_this$bundleUnitStore8 = this.bundleUnitStore.unit) === null || _this$bundleUnitStore8 === void 0 ? void 0 : _this$bundleUnitStore8.items),
      addToCartContext: this.props.context,
      cartButtonTextAdd: this.getCartButtonTextAdd(),
      className: styles['add-to-cart'],
      allowAddToCartSuccessModal: this.props.allowAddToCartSuccessModal,
      forceGoToCart: this.getForceGoToCart(),
      cartButtonTextGoToCart: this.getCartButtonTextGoToCart(),
      urlParamsOnAdd: isBundleDiscountEnabled ? {
        has_bundle: 'True'
      } : undefined
    })));
  }
  render() {
    if (this.bundleUnitStore.loading) {
      return this.renderInContainer(/*#__PURE__*/React.createElement(BundleUnitSkeleton, {
        isSingleSelectableUnit: this.props.isSingleSelectableUnit
      }));
    }
    if (!this.getBundleUnitItems().length) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      "data-purpose": "bundle-wrapper"
    }, this.renderInContainer(this.renderUnit()));
  }
}, _InternalBundleUnit.defaultProps = {
  titleTypography: undefined,
  unit: undefined,
  subtitle: undefined,
  applyBorder: true,
  context: {
    fbt_add_to_cart: true
  },
  allowAddToCartSuccessModal: true,
  forceGoToCart: false,
  isSingleSelectableUnit: false,
  isBundleDiscountEnabled: false,
  bundleDiscountCode: ''
}, _InternalBundleUnit.contextType = AsyncPriceCourseCardContext, _InternalBundleUnit)) || _class;
export const BundleUnit = withI18n(withUDData(InternalBundleUnit));
//# sourceMappingURL=bundle-unit.react-component.js.map